import { httpGet, IResponse } from "../network";
import { base_url } from "../../constants/api";
export type TDepartment={
    id: number,
    department_name: string
}
export const fetchDepartments=()=>{
    return httpGet<TDepartment[]>(`${base_url}/consultation/consultation-department`);
}